import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteChannel {
        __typename
        id
        name
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Channels/DeleteSubscription.js